import { render, staticRenderFns } from "./SubTitle5.vue?vue&type=template&id=61a60288&scoped=true&"
import script from "./SubTitle5.vue?vue&type=script&lang=js&"
export * from "./SubTitle5.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle5.vue?vue&type=style&index=0&id=61a60288&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a60288",
  null
  
)

export default component.exports